export default function setGridTopoSwiper() {
  const gridTopo = document.querySelectorAll('[data-grid-swiper]');

  if (gridTopo.length > 0) gridTopo.forEach(section => {
    const slide = new Swiper(section, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 16,
        watchOverflow: true,
      });
    });
}
